import { render, staticRenderFns } from "./PromoConfigSettings.vue?vue&type=template&id=10bce788&scoped=true&"
import script from "./PromoConfigSettings.vue?vue&type=script&lang=js&"
export * from "./PromoConfigSettings.vue?vue&type=script&lang=js&"
import style0 from "./PromoConfigSettings.vue?vue&type=style&index=0&id=10bce788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bce788",
  null
  
)

export default component.exports